import { useMutation } from '@tanstack/react-query'
import { confirmAnonymousPayment } from '../../service/payment'

function useConfirmAnonymousPayment() {
  return useMutation({
    mutationKey: ['confirm-anonymous-payment'],
    mutationFn: confirmAnonymousPayment,
  })
}

export default useConfirmAnonymousPayment